import type { ThemeMode } from '../store/slices';

/** Auth screens are always light so the branded login stays consistent. */
export function effectiveThemeMode(
  pathname: string,
  storedMode: ThemeMode
): ThemeMode {
  if (pathname === '/auth' || pathname.startsWith('/auth/')) {
    return 'light';
  }
  return storedMode;
}
